import { ACTION_TYPE, CASE_ATTRIBUTE } from '../../../../../interfaces/enums';
import type { RuleTemplate } from '../../../../../interfaces/Interfaces';
import { ValidationResult } from '../../../../DunningSelectionPage/DunningSelection/input/Validators';

export function validateConditionIfCancelDebtCollectionAction(ruleEdit: RuleTemplate): ValidationResult | null {
  const hasCancelDebtCollectionAction =
    ruleEdit.actions.filter(action => action['@type'] === ACTION_TYPE.CANCEL_DEBT_COLLECTION).length > 0;

  if (!hasCancelDebtCollectionAction) {
    return null;
  }

  const hasChangeOfStatusAction =
    ruleEdit.actions.filter(action => action['@type'] === ACTION_TYPE.CHANGE_OF_STATUS).length > 0;

  if (!hasChangeOfStatusAction) {
    return {
      error: true,
      message: 'error.rule-editor.missing-cancel-debt-collection-cond',
    };
  }

  const hasChangeOfLevelCondition =
    ruleEdit.caseConditions.filter(condition => condition.attrib === CASE_ATTRIBUTE.LEVEL).length > 0;

  if (!hasChangeOfLevelCondition) {
    return {
      error: true,
      message: 'error.rule-editor.missing-change-of-level-cond',
    };
  }

  return null;
}
